import { useGetSiteEmployeeProductUpdates } from './get-site-employee-product-updates/hook';
import { useSetSiteEmployeeProductUpdatesRead } from './set-site-employee-product-updates-read/hook';

export const ProductUpdates = {
  useGetSiteEmployeeProductUpdates,
  useSetSiteEmployeeProductUpdatesRead,
};
